export const IMAGE_HEIGHT = 595;
export const IMAGE_WIDTH = 1168;
export const VIDEO_IMAGE_SCALE = 0.75;
